import React, { useRef, forwardRef, useImperativeHandle } from "react";
import DatePicker from "react-datepicker";
import { CiCalendar } from "react-icons/ci";
import { getYear, getMonth } from "date-fns"; 
import "react-datepicker/dist/react-datepicker.css";
import "./CustomSelect.css";

const years = Array.from({ length: 50 }, (_, i) => getYear(new Date()) - 0 + i);
const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const CustomDatePicker = forwardRef(
  (
    {
      label,
      name,
      selected,
      onChange,
      minDate,
      maxDate,
      placeholder = "dd-mm-yyyy",
      required = false,
      error = "",
      className = "",
    },
    ref
  ) => {
    const datePickerRef = useRef(null);
    const inputRef = useRef(null);

    const openPicker = () => {
      if (datePickerRef.current?.setOpen) {
        datePickerRef.current.setOpen(true);
      }
    };

    useImperativeHandle(ref, () => ({
      scrollIntoView: (options) => inputRef.current?.scrollIntoView(options),
      focus: () => inputRef.current?.focus(),
      addHighlight: () => inputRef.current?.classList.add("field-highlight"),
      removeHighlight: () => inputRef.current?.classList.remove("field-highlight"),
      dom: inputRef.current,
    }));

    return (
      <div className={`custom-date-group ${className}`}>
        {label && (
          <label className="custom-date-label">
            {label} {required && <span className="text-danger">*</span>}
          </label>
        )}

        <div className={`date-wrapper ${error ? "date-error" : ""}`}>
          <DatePicker
            ref={(el) => {
              datePickerRef.current = el;
              inputRef.current = el?.input;
            }}
            selected={selected}
            onChange={onChange}
            minDate={minDate}
            maxDate={maxDate}
            dateFormat="dd-MM-yyyy"
            placeholderText={placeholder}
            className="react-date-input"
            
            // --- Custom Header Implementation ---
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <div className="custom-datepicker-header">
                {/* Previous Month Button */}
                <button 
                  type="button"
                  onClick={decreaseMonth} 
                  disabled={prevMonthButtonDisabled}
                  className="nav-btn"
                >
                  {"<"}
                </button>

                {/* Dropdowns Container */}
                <div className="dropdowns-container">
                  {/* Month Dropdown */}
                  <select
                    value={months[getMonth(date)]}
                    onChange={({ target: { value } }) =>
                      changeMonth(months.indexOf(value))
                    }
                    className="custom-select-month"
                  >
                    {months.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>

                  {/* Year Dropdown */}
                  <select
                    value={getYear(date)}
                    onChange={({ target: { value } }) => changeYear(value)}
                    className="custom-select-year"
                  >
                    {years.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Next Month Button */}
                <button 
                  type="button"
                  onClick={increaseMonth} 
                  disabled={nextMonthButtonDisabled}
                  className="nav-btn"
                >
                  {">"}
                </button>
              </div>
            )}
          />

          <CiCalendar className="date-icon" onClick={openPicker} />
        </div>

        {error && <div className="custom-date-error">{error}</div>}
      </div>
    );
  }
);

export default CustomDatePicker;